import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import ComingSoon from './pages/ComingSoon';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import CookiePolicy from './pages/CookiePolicy';
import About from './pages/About';

/**
 * AppWrapper - Controls app display based on time and provides legal pages
 *
 * AUTOMATIC SCHEDULE:
 * - Monday Nov 4, 2025 11:30 AM → Full App Goes Live
 * - Monday Nov 4, 2025 8:00 PM → Coming Soon Mode
 * - Legal pages ALWAYS accessible (required for app store submissions)
 */
const AppWrapper: React.FC = () => {
  const now = new Date();

  // Launch schedule (IST - India Standard Time UTC+5:30)
  // SET YOUR LAUNCH DATE/TIME HERE:
  const launchStart = new Date('2025-12-31T23:59:00+05:30'); // Future date - Coming Soon by default
  const launchEnd = new Date('2026-01-01T23:59:00+05:30');   // Future date

  // Check if we're in the launch window
  const isLaunchWindow = now >= launchStart && now < launchEnd;

  // Manual override from environment (for testing)
  const manualOverride = import.meta.env.VITE_COMING_SOON;

  // ALWAYS show full app - Coming Soon disabled
  let showFullApp = true;

  console.log('🎯 App Status:', {
    currentTime: now.toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' }),
    launchStart: launchStart.toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' }),
    launchEnd: launchEnd.toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' }),
    isLaunchWindow,
    manualOverride,
    showFullApp: showFullApp ? 'FULL APP' : 'COMING SOON'
  });

  return (
    <BrowserRouter>
      <Routes>
        {/* Legal Pages - ALWAYS ACCESSIBLE */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/cookies" element={<CookiePolicy />} />
        <Route path="/about" element={<About />} />

        {/* App Routes or Coming Soon */}
        {showFullApp ? (
          <Route path="/*" element={<App />} />
        ) : (
          <Route path="/*" element={<ComingSoon />} />
        )}
      </Routes>
    </BrowserRouter>
  );
};

export default AppWrapper;
